import React from 'react'
import { camIconPrefix } from '@src/constants/icons'
import cx from 'classnames'
import '@src/fonts/cam-icons/css/sailpoint-icons.css'

interface Props {
  name: CAMIconName
  className?: string
}

const getIconClass = (icon: CAMIconName) => `${camIconPrefix}${icon}`

const Icon: React.FC<Props> = ({ name, className }: Props) => (
  <i className={cx(className, getIconClass(name))} />
)

export default Icon
